<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">已检一览</h1>-->
    <!--</header>-->
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">已检一览</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="border-bottom: 1px dashed #CCCCCC;margin-top: 15px;">
        <!--第一行-->
        <div class="sampling-first-title" style="padding-left: 0px;">
          <h4 style="padding-left: 8px;">基础信息</h4>
        </div>
        <!--第二行内容-->
        <div class="sampling-first-content">
          <!--第1行-->
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left">
              <span>外注订单:</span>
            </div>
            <div class="flex-9">
              <span>{{ddh}}</span>
            </div>
          </div>
          <!--第2行-->
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left">
              <span>物料:</span>
            </div>
            <div class="flex-9">
              <span>{{scxtwph}} {{scxtwpmc}}</span>
            </div>
          </div>
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left">
              <span>订单数量:</span>
            </div>
            <div class="flex-9">
              <span>{{sl}}{{dw}}</span>
            </div>
          </div>
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;">
            <div style="text-align: right;padding-right: 6px;color: #333333;"><!-- class="sampling-first-content-left" -->
              <span>已检数量（含已出库指示）:</span>
            </div>
            <div class="flex-9">
              <span>{{yjsl}}{{dw}}</span>
            </div>
          </div>
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;">
            <div style="text-align: right;padding-right: 6px;color: #333333;"><!-- class="sampling-first-content-left" -->
              <span>在库剩余:</span>
            </div>
            <div class="flex-9">
              <span>{{syzksl}}{{dw}} {{syzkps}}匹  {{syzkjs}}卷 </span>
            </div>
          </div>
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↓ -->
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;display: block;" class="hover-container">
            <div style="flex-grow: 1;display:flex">
              <div style="color: #333333;width:110px;"><!-- class="sampling-first-content-left" -->
                <span>订单未打卡数量:</span>
              </div>
              <div style="width:calc(100% - 110px);">
                <span>{{sysl}}{{dw}}</span>
                <span class="mui-icon mui-icon-info hover-trigger" style="font-size:20px;color:#1F6FB5" ></span>
              </div>
            </div>
            <div style="flex-grow: 1;font-size: 14px;padding-top: 0px;padding-bottom: 3px;margin-top:3px;" class="hover-content">
              <div class="hover-reveal" style="width:100%">订单未打卡数量 = 订单量 - TSD实际入库量（包含系统入库和无系统入库） - 生产未出库量 - 在途量</div>
            </div>
          </div>
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↑ -->
        
          <!--第2行-->
          <!--<div style="display: flex;padding-top: 0px;padding-bottom: 3px;">-->
            <!--<div class="flex-1" style="font-size: 14px;display: flex;">-->
              <!--<div class="sampling-first-content-left flex-3">-->
                <!--<span>订单数量:</span>-->
              <!--</div>-->
              <!--<div class="flex-3">-->
                <!--<span>{{sl}}{{dw}}</span>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="flex-1" style="font-size: 14px;display: flex;">-->
              <!--<div class="sampling-first-content-left flex-3">-->
                <!--<span>已检数量:</span>-->
              <!--</div>-->
              <!--<div class="flex-3">-->
                <!--<span>{{yjsl}}{{dw}}</span>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->

        </div>
        <!--<div class="sampling-first-content" style="font-size: 14px;">-->
          <!--<div class="sampling-first-content" style="display: flex;">-->
            <!--&lt;!&ndash;第1行&ndash;&gt;-->
            <!--<div style="flex: 3;display: flex;">-->
              <!--<span>外注订单：</span>-->
              <!--<span>{{ddh}}</span>-->
            <!--</div>-->
            <!--&lt;!&ndash;第2行&ndash;&gt;-->
            <!--<div style="flex: 2;display: flex;">-->
              <!--<span>订单数量：</span>-->
              <!--<span>{{sl}}{{dw}}</span>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="sampling-first-content" style="display: flex;">-->
            <!--&lt;!&ndash;第1行&ndash;&gt;-->
            <!--<div style="flex: 3;display: flex;">-->
              <!--<span>物料：</span>-->
              <!--<span>{{scxtwph}} {{scxtwpmc}}</span>-->
            <!--</div>-->
            <!--&lt;!&ndash;第2行&ndash;&gt;-->
            <!--<div style="flex: 2;display: flex;">-->
              <!--<span>已检数量：</span>-->
              <!--<span>{{yjsl}}{{dw}}</span>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="sampling-first" style="margin-top: 15px;border-bottom: 0px;">
        <!--第一行-->
        <div class="sampling-first-title">
          <h4 style="position: relative;text-align: left;">已检明细
              <span style="position: absolute;right: 10px;" v-show="ddqf=='1'">抽检数量：{{cjsl}}{{dw}}({{cjjs}}卷 {{cjps}}匹)</span>
          </h4>
        </div>
        <div class="sampling-first-content">
          <!--第一行 ※说明-->
          <div class="sampling-first-title" style="color:#ff0000; padding: 0px 10px;" v-show="ddqf=='2'">
            <span style="padding:0px 5px 0px 5px">*</span><span style="margin-left:2px;">代表验布记录已录</span>
          </div>
          <ul class="mui-table-view">
            <li class="mui-table-view-cell flex-content" style="display: block;margin-bottom: 10px;" v-for="(item,i) in infoLst" v-if="showcheck(item)">
              <div class="mui-slider-right mui-disabled">
                <a class="mui-btn mui-btn-yellow" @tap="detail(item, $event,'read','')">详情</a>
                <a class="mui-btn mui-btn-purple" v-if="(item.statusflg=='0') && (!item.zdflg) && (!isTSD) && (inspectflag=='0') && (ddqf=='2')" @tap="detail(item, $event,'edit','YB')">验布记录</a>
                <a class="mui-btn mui-btn-red" v-if="(item.statusflg=='0') && (!item.zdflg) && (!isTSD) && (zjlrzt!='01')" @tap="del(item,$event)">删除</a>
              </div>
              <div class="mui-slider-handle">
                <div class="mui-table-cell">
                  <div class="flex-box" style="display: flex;flex-wrap: wrap;">
                    <div class="flex-container">
                      <div class="flex-content-container" style="display: flex;">
                        <div class="flex-content-span flex-1" style="width:25px;text-align:center;font-weight:bold;">
                          <div v-if="(ddqf=='2' && item.checkremark!='')" style="color: #ff0000;float: left;height: 15px;margin-top: 3px;">*</div>
                          <span>{{(i+1)}}</span>
                        </div>
                        <div class="flex-content-label" style="padding-right: 0px;min-width: 35px;">{{ddqf=='3'?'反番号':'外注卷号'}}:</div>
                        <div class="flex-content-span flex-1"><span style="white-space:nowrap;">{{item.wzrollno}}</span></div>
                      </div>
                    </div>
                    <div class="flex-container" style="margin-left: 5px;margin-right: 10px;">
                      <div class="flex-content-container flex-2" style="min-width:80px;display: flex;">
                        <div class="flex-content-label" style="min-width: 35px;padding-left:6px;">数量:</div>
                        <div class="flex-content-span flex-1"><span>{{item.sl}}{{dw}}</span></div>
                        <!--<span style="margin-left: 10px;" class="flex-gray">{{item.grade=='B'?'悬念反':item.grade}}</span>-->
                      </div>
                      <!--<div class="flex-content-container flex-1">-->
                        <!--<span :class="[item.cjgrade=='B'?'flex-red':'flex-green']">{{item.cjgrade?(item.cjgrade=='B'?'悬念反':('抽（'+item.cjgrade+'）')):''}}</span>-->
                      <!--</div>-->
                    </div>
                    <div  class="flex-container" style="vertical-align: middle;display: table-cell;">
                      <span style="margin-left: 10px;" class="flex-gray">{{item.grade=='B'?'悬念反':item.grade}}</span>
                      <span :class="[item.cjgrade=='B'?'flex-red':'flex-green']">{{item.cjgrade?(item.cjgrade=='B'?'悬念反':('抽（'+item.cjgrade+'）')):''}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "qualityList",
  data() {
    return {
      ddh: "",
      wph: "",
      scxtwph: "",
      scxtwpmc: "",
      sl: "",
      dw: "",
      yjsl: "",
      cjsl: "",
      infoLst: [],
      ksbh: "",
      ddqf:"",
      isTSD: false,
      statusflg: "",
      cjjs: "",
      inspectflag: "",
      syzksl:"",// 剩余在库数量
      syzkps:"",// 剩余在库匹数
      syzkjs:"",// 剩余在库卷数
      cjps:"",//抽检匹数
      zjlrzt:"",// 质检录入状态
      sysl:"" // 20250811 剩余未打卡数量
    }
  },
  created() {},
  activated() {
    var v = this;
    const para = getJsonPara(v.$route);
    if (para) {
      v.ddh = para.ddh;
      v.wph = para.wph;
      v.ksbh = para.ksbh;
      v.getListbyzj();
    }
  },
  methods: {
    showcheck(item){
      if(this.isTSD){
        if(item.cjgrade){
          return true;
        }else{
          return false;
        }
      }else{
        return true;
      }
    },
    getListbyzj() {
      var v = this;
      v.nyy.doPost("/Quality/getListbyzj", {
          ddh: v.ddh,
          wph: v.wph
        },
        function(result) {
          if (result.status) {
            var info = result.data.info;
            v.scxtwph = info.scxtwph;
            v.scxtwpmc = info.scxtwpmc;
            v.sl = info.sl;
            v.dw = info.dw;
            v.yjsl = info.yjsl;
            v.cjsl = info.cjsl;
            v.ddqf = info.ddqf;
            v.infoLst = info.list ? JSON.parse(info.list) : [];
            v.statusflg = info.statusflg;
            v.isTSD = result.data.isTSD;
            v.cjjs = info.cjjs;
            v.inspectflag = info.inspectflag;
            v.syzksl = info.syzksl;
            v.syzkps = info.syzkps;
            v.syzkjs = info.syzkjs;
            v.cjps = info.cjpstotal;
            v.zjlrzt = info.zjlrzt;// 质检录入状态
            v.sysl = info.sysl; // 2025.08.11 追加
          }
        }
      );
    },
    del(item,el) {
      var v = this;
      var li =$(el.target).parents('li');
      if(li.length<=0)return;
      li = li[0];

      var postMap = item;
      postMap.ddqf = v.ddqf;
      postMap.ddh = v.ddh;
      postMap.wph = v.wph;

      mui.confirm('确定删除TSD卷号' + item.tsdrollno + '质检记录？', '提示', ['否', '是'], function(e) {
        setTimeout(function() {
          mui.swipeoutClose(li);
        }, 0);
        
        if (e.index == 1) {
          v.nyy.doPost("/Quality/del",postMap,
            function(result) {
              if (result.status) {
                v.getListbyzj();
              } else {
                mui.toast(result.message);
              }
            }
          );
        }
      });
    },
    detail(item, e,type,biztype) {
      var v = this;

      var li =$(e.target).parents('li');
      if(li.length<=0)return;
      li = li[0];

      setTimeout(function() {
        mui.swipeoutClose(li);
      }, 0);

      if(v.ddqf=='2'){
        if(biztype == "YB"){
          var para_info = { "ddh": v.ddh, "wph": v.wph,"tsdrollno": item.tsdrollno };
          v.$router.push({ "name": "qualityDetailYB", params: jsonPara(para_info) });
        }else{
           if(v.wph.startsWith("0103")){ // 经编
              v.$router.push({ "name": "qualityDetailBZJB", params: { "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph, "tsdrollno": item.tsdrollno,"type": type  }});
           }else{
              // v.$router.push({ "name": "qualityDetailBZ", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph, "tsdrollno": item.tsdrollno,"type": type }) });
              v.$router.push({ "name": "qualityDetailBZ", params: { "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph, "tsdrollno": item.tsdrollno,"type": type  }});
           }
        }
      }else{
        v.$router.push({ "name": "qualityDetail", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph, "tsdrollno": item.tsdrollno,"iscj":v.isTSD,"idx": item.idx, "readonly": ((v.statusflg!='0'&&v.isTSD)?true:false) }) });
      }
    }
  }
}
</script>
<style scoped>
@import "../../static/css/sampling.css";
@import "../../static/css/samplinghistory.css";
@import "../../static/css/quality.css";
</style>



// WEBPACK FOOTER //
// src/components/qualityList.vue